// @ts-nocheck
import React, { useState, createContext, useContext } from "react";
import { useAuth } from "../../Auth/State/AuthContext";

import axios from "axios";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import {
    RUTA_API_ALIAS,
    RUTA_API_AREAS,
    RUTA_API_DIFUSIONES,
    URL_API_SIA,
} from "../../Contantes/Constantes";

const DifusionesContext = createContext({});

export const useDifusiones = () => useContext(DifusionesContext);

export const ProvideDifusiones = ({ children }) => {
    const axiosInstance = setupInterceptorsTo(
        axios.create({
            headers: {
                "Content-Type": "application/json",
            },
        })
    );
    const { user, hasRole } = useAuth();
    const [difusiones, setDifusiones] = useState([]);
    const [areasUser, setAreasUser] = useState([]);
    const [listas, setListas] = useState([]);

    const obtenerDifusiones = async () => {
        let validResponse = false;
        try {
            const response = await axiosInstance.get(`${RUTA_API_DIFUSIONES}/all/difusiones`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener difusiones: ", error);
        }
    };

    const obtenerDifusionesByUser = async () => {
        try {
            const response = await axiosInstance.get(`${RUTA_API_DIFUSIONES}/difusiones/${user.uidnumber}`);

            setDifusiones(response.data);
            return difusiones;
        } catch (error) {
            console.error("Error al intentar traer las difusiones: ", error);
        }
    };

    const obtenerDifusionesByAreas = async (areas) => {
        try {
            const response = await axiosInstance.post(`${RUTA_API_DIFUSIONES}/difusiones/by-areas`, areas);
            setDifusiones(response.data);
            return response.data;
        } catch (error) {
            console.error("Error al intentar traer las difusiones por áreas: ", error);
        }
    };

    const obtenerDifusionesByAlias = async (alias) => {
        try {
            const response = await axiosInstance({
                method: "GET",
                url: `${RUTA_API_DIFUSIONES}/difusiones/alias/${alias}`,
            });
            return response.data;
        } catch (error) {
            console.error("Error al intentar traer las difusiones de un alias: ", error);
        }
    };

    const obtenerDifusionesByArea = async (areaId) => {
        try {
            const config = {
                method: "GET",
                url: `${RUTA_API_DIFUSIONES}/difusiones/area/${areaId}`,
            };
            const response = await axiosInstance(config);

            return response.data;
        } catch (error) {
            console.error("Error al intentar traer las difusiones de un area: ", error);
        }
    };

    const obtenerDifusion = async (difusionId) => {
        let validResponse = false;
        try {
            const response = await axiosInstance.get(`${RUTA_API_DIFUSIONES}/difusion/${difusionId}`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener difusión: ", error);
            throw error;
        }
    };

    const obtenerAperturasDifusion = async (idDifusion) => {
        try {
            const config = {
                method: "get",
                url: `${RUTA_API_DIFUSIONES}/apertura/${idDifusion}`,
            };
            const response = await axiosInstance(config);
            return response.data;
        } catch (error) {
            console.error("Error al intentar obtener las aperturas de una difusion: ", error);
        }
    };

    const crearDifusion = async (data) => {
        try {
            const config = {
                method: "post",
                url: `${RUTA_API_DIFUSIONES}/email/crear`,
                data,
            };
            const response = await axiosInstance(config);
            return response.data;
        } catch (error) {
            console.error("Error al intentar crear la difusion: ", error);
            throw error;
        }
    };

    const actualizarEstadoDifusiones = async () => {
        const estadosYIds = difusiones
            .filter((difusion) => difusion.estado !== 1 && difusion.estado !== 4)
            .map((difusion) => ({ id: difusion.id, estado: difusion.estado }));

        try {
            const response = await axiosInstance({
                method: "GET",
                url: `${RUTA_API_DIFUSIONES}/difusiones/actualizar/estado`,
                params: {
                    estados: JSON.stringify(estadosYIds),
                },
            });

            if (response.data.length > 0) {
                const nuevosEstados = response.data;
                const difusionesActualizadas = difusiones.map((difusion) => {
                    const match = nuevosEstados.find(
                        (estado) => estado.id === difusion.id
                    );
                    return match ? { ...difusion, estado: match.estado } : difusion;
                });
                setDifusiones(difusionesActualizadas);
            }
        } catch (error) {
            console.error("Error al actualizar el estado de las difusiones: ", error);
        }
    };

    const eliminarDifusion = async (difusionId) => {
        try {
            await axiosInstance.delete(`${RUTA_API_DIFUSIONES}/email/${difusionId}`);
        } catch (error) {
            console.error("Error al eliminar difusión: ", error);
            throw error;
        }
    };

    const obtenerFirmas = async () => {
        try {
            const config = {
                method: "GET",
                url: `${RUTA_API_DIFUSIONES}/firma/uid/${user.uid}`,
            };
            const response = await axiosInstance(config);

            return response.data;
        } catch (error) {
            console.error("Error al traer las firmas: ", error);
        }
    };

    const obtenerAliasesRemitente = async () => {
        try {
            const response = await axiosInstance.get(`${RUTA_API_ALIAS}/remitente/${user.uid}`);
            return Array.isArray(response.data)
                ? response.data.map(a => ({ nombreAlias: a.nombre, mail: a.mail }))
                : [];
        } catch (error) {
            console.error("Error al obtener aliases del remitente: ", error);
            return [];
        }
    };

    const obtenerFirmaAlias = async (nombreAlias) => {
        try {
            const config = {
                method: 'GET',
                url: `${RUTA_API_DIFUSIONES}/firma/alias/${nombreAlias}`,
            };
            const response = await axiosInstance(config);
            return response.data;
        } catch (error) {
            console.error("Error al obtener la firma del alias: ", error);
        }
    };

    const actualizarFirma = async (firmas) => {
        try {
            const config = {
                method: 'PUT',
                url: `${RUTA_API_DIFUSIONES}/firma/put`,
                data: firmas,
            };
            const response = await axiosInstance(config);
            return response.data;
        } catch (error) {
            console.error("Error al actualizar las firmas: ", error);
            throw error
        }
    };

    const obtenerListas = async () => {
        try {
            const params = new URLSearchParams();
            areasUser.forEach(area => params.append('ids[]', area.id));
            const response = await axiosInstance.get(`${RUTA_API_DIFUSIONES}/destinatarios/by-areas?${params.toString()}`);
            const listas = response.data.flat().map(destinatario => ({
                ...destinatario,
                cantidadDeCorreos: destinatario.integrantes.length,
            }));
            listas.sort((a, b) => a.nombre.localeCompare(b.nombre));

            setListas(listas);

            // const listaSIU = await obtenerListasSiu(); Por ahora no se traeran estas listas
            // const listaLdap = await obtenerListasLdap(); Por ahora no se traeran estas listas
            // let aplanado = listas.concat(listaSIU).concat(listaLdap).flat();

            return listas;
        } catch (error) {
            console.error("Error al traer las listas: ", error);
        }
    };

    const obtenerListasPorArea = async (areaId) => {
        try {
            const config = {
                method: "GET",
                url: `${RUTA_API_DIFUSIONES}/destinatarios/${user.uidnumber}/${areaId}`,
            };
            const response = await axiosInstance(config);
            const listas = response.data.sort((a, b) => a.nombre.localeCompare(b.nombre));

            return listas;
        } catch (error) {
            console.error("Error al obtener listas del área: ", error);
        }
    };

    const obtenerListasLdap = async () => {
        try {
            const config = {
                method: "get",
                url: `${RUTA_API_DIFUSIONES}/predetermindas/ldap`,
            };
            const response = await axiosInstance(config);
            return await Object.values(response.data).map((valor) => valor);
        } catch (error) {
            console.error("Error al obtener listas LDAP: ", error);
        }
    };

    const obtenerListasSiu = async () => {
        try {
            const config = {
                method: "get",
                url: `${RUTA_API_DIFUSIONES}/predetermindas/siu`,
            };
            const response = await axiosInstance(config);
            return await Object.values(response.data).map((valor) => valor);
        } catch (error) {
            console.error("Error al obtener listas SIU: ", error);
        }
    };

    const crearLista = async (data) => {
        try {
            const config = {
                method: "POST",
                url: `${RUTA_API_DIFUSIONES}/destinatario`,
                data,
            };

            const response = await axiosInstance(config);
        } catch (error) {
            console.error("Error al crear la lista: ", error);
            throw error;
        }
    }

    const editarLista = async (listaId, data) => {
        try {
            const response = await axiosInstance.put(`${RUTA_API_DIFUSIONES}/destinatario/${user.uidnumber}/${listaId}`, data);
        } catch (error) {
            console.error("Error al modificar la lista:", error);
            throw error;
        }
    }

    const desvincularLista = async (listaId, compartidos) => {
        try {
            const response = await axiosInstance({
                method: 'PUT',
                url: `${RUTA_API_DIFUSIONES}/destinatario/eliminar/compartidos/${user.uidnumber}`,
                data: {
                    destinatarioId: listaId,
                    compartidosAEliminar: compartidos,
                },
            });
        } catch (error) {
            console.error("Error al desvincular la lista:", error);
        }
    };

    const eliminarLista = async (listaId) => {
        try {
            const response = await axiosInstance({
                method: 'DELETE',
                url: `${RUTA_API_DIFUSIONES}/destinatario/${user.uidnumber}/${listaId}`,
            });
        } catch (error) {
            console.error("Error al eliminar la lista:", error);
            throw error;
        }
    };

    const obtenerAlias = async () => {
        try {
            const params = new URLSearchParams();
            areasUser.forEach(area => params.append('ids[]', area.id));
            const response = await axiosInstance.get(`${URL_API_SIA}/areas/alias/areas?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error("Error al obtener alias: ", error);
            throw error;
        }
    };

    const alcanzoLimiteAlias = async (alias) => {
        try {
            const response = await axiosInstance({
                method: "GET",
                url: `${URL_API_SIA}/difusender/estado/${alias}`,
            });
            return response.data;
        } catch (error) {
            console.error("Error al consultar el limite de envios del alias: ", error);
        }
    };

    const obtenerAreas = async () => {
        try {
            const response = await axiosInstance({
                method: "GET",
                url: `${RUTA_API_AREAS}/usuarios/${user.uidnumber}/areas`,
            });

            setAreasUser(response.data);

            return response.data;
        } catch (error) {
            console.error("Error al traer las áreas: ", error);
        }
    };

    return (
        <DifusionesContext.Provider
            value={{
                difusiones,
                areasUser,
                listas,
                obtenerDifusiones,
                obtenerDifusionesByUser,
                obtenerDifusionesByAlias,
                obtenerDifusionesByArea,
                obtenerDifusion,
                obtenerAperturasDifusion,
                crearDifusion,
                actualizarEstadoDifusiones,
                eliminarDifusion,
                obtenerFirmas,
                obtenerAliasesRemitente,
                obtenerFirmaAlias,
                actualizarFirma,
                obtenerListas,
                obtenerListasPorArea,
                crearLista,
                editarLista,
                desvincularLista,
                eliminarLista,
                obtenerAlias,
                alcanzoLimiteAlias,
                obtenerAreas,
                obtenerDifusionesByAreas
            }}
        >
            {children}
        </DifusionesContext.Provider>
    )
}
